import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import MediaQuery from 'react-responsive';

import { useSelector } from 'react-redux';

import { FetchLikePlusPointsToCash, FetchLikePlusRedemption } from 'Services/Apis/likePlus/likePlusServices';
import { cloudloyalty } from 'Services/Apis/clients';
import usePipeContext from 'Services/Providers/PipeProvider/usePipeContext';

import { Form } from 'antd';

import {
  Col,
  Row,
  VertButton,
  VertCheckbox,
  VertContainer,
  VertIcon,
  VertInput,
  VertInputMask,
  VertLoading,
  VertModal,
  VertSelect,
  VertTypography,
  message,
  VertAlert,
  Divider,
} from '@vertem-core/vertice-ds';

import { InfoCircleOutlined } from '@ant-design/icons';

import initialTokensValues from 'Assets/skins/default';
import 'Assets/styles/default/components/LikePlus/LikePlusGetYourStyles.less';

import LikePlusCustomTerms from '../LikePlusCustomTerms';
import { useCheckoutProvider } from 'components/Checkout/CheckoutProvider';
import { CheckoutModal2FA } from 'components/2FA/CheckoutModal2FA';

import Joi from 'joi';

import { convertStringToDate, isAdultAndValidDate } from 'Utils/commons/date';
import { currencyMask } from 'Utils/commons/cash';
import { onlyNumbersByDecimalPlaces } from 'Utils/onlyNumbers';
import { phoneMask, cepMask } from 'Utils/commons/mask';
import { pointsMask } from 'Utils/commons/points';
import { handleAddressNumberOutput, StateList } from 'Utils/commons/address';
import { stringToNumber } from 'Utils/commons/string';
import { convertPriceToPoints } from 'Utils/convertPoints';
import generateUUID from 'Utils/generateUUID';
import validateAddress from 'Utils/validateAddress';

import yn from 'yn';
import OnboardingRedirectModal from 'components/Onboarding/OnboardingRedirectModal';

import { cardCustomLabel, deliveryTime, maxCardLoad, minCardLoad, profileEditionPortal, profileEditionUrl } from 'Constants/LikePlus';

const LikePlusGetYour = () => {
  const [useForm] = Form.useForm();
  const { callApi } = usePipeContext();
  const navigate = useNavigate();

  const Balance = useSelector(({ Balance: data }) => data);
  const Catalog = useSelector(({ Catalog: data }) => data);
  const userInfos = useSelector(({ oidc: data }) => data);
  const Participants = useSelector(({ Participants: data }) => data);
  const [orderId, setOrderId] = useState(null);
  const [orderStatus, setOrderStatus] = useState(null);
  const [purchaseData, setPurchaseData] = useState(null);
  const [isFormFilled, setIsFormFilled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [invalidZipcode, setInvalidZipcode] = useState(false);
  const [isTotalPointsChecked, setIsTotalPointsChecked] = useState(false);
  const [cashValue, setCashValue] = useState('0');
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [errorModalMessage, setIsErrorModalMessage] = useState('');
  const [formValues, setFormValues] = useState({
    pointsQtd: 0,
    fullName: '',
    document: '',
    birthDate: '',
    phone: '',
    email: '',
    zipcode: '',
    state: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    reference: 'Nenhum',
  });
  const [isAddressWithoutNumber, setIsAddressWithoutNumber] = useState(false);
  const { handleAddErrors, errors } = useCheckoutProvider();
  const [taxes, setTaxes] = useState({});
  const [showOnboardingModal, setShowOnboardingModal] = useState(false);

  const userTotalPoints =
    Balance && Balance.pointsValue ? Balance.pointsValue : 0;
  const {
    currencyConfiguration: { decimalPlaces, pointsName, conversionRate },
  } = Catalog;
  const formattedUserPoints = pointsMask(
    userTotalPoints,
    decimalPlaces,
    pointsName
  );
  const formattedPointsQtd = pointsMask(
    formValues.pointsQtd,
    decimalPlaces,
    pointsName
  );
  const disableButton = !isFormFilled || !acceptedTerms || isLoading;

  const likePlusLoadMinLimit = minCardLoad;
  const likePlusLoadMaxLimit = maxCardLoad;

  const formattedLikePlusLoadMinLimit = pointsMask(
    minCardLoad,
    decimalPlaces,
    pointsName
  );

  const formattedLikePlusLoadMaxLimit = pointsMask(
    maxCardLoad,
    decimalPlaces,
    pointsName
  );

  const schema = Joi.object({
    pointsQtd: Joi.required().custom((value, helpers) => {
      const numericValue = stringToNumber(value);

      if (!numericValue || numericValue === 0) {
        return helpers.message({ custom: `Digite a quantidade de ${pointsName} corretamente` });
      }

      if (likePlusLoadMinLimit && numericValue < likePlusLoadMinLimit) {
        return helpers.message({
          custom: `Não atinge o mínimo de ${formattedLikePlusLoadMinLimit?.value} ${formattedLikePlusLoadMinLimit?.label}`,
        });
      }

      if (numericValue > userTotalPoints) {
        return helpers.message({ custom: `Saldo insuficiente` });
      }

      if (likePlusLoadMaxLimit && numericValue > likePlusLoadMaxLimit) {
        return helpers.message({
          custom: `Ultrapassa o máximo de ${formattedLikePlusLoadMaxLimit?.value} ${formattedLikePlusLoadMaxLimit?.label}`,
        });
      }
    }),
    fullName: Joi.string().min(5).required().trim().messages({
      'string.empty': 'Digite seu nome completo',
      'string.min': 'Mínimo de 5 caracteres',
    }),
    document: Joi.string().required().trim().messages({
      'string.empty': 'Digite seu cpf',
    }),
    birthDate: Joi.string()
      .required()
      .custom((value, helpers) => {
        const isValidDate = isAdultAndValidDate(value);
        if (!isValidDate) {
          return helpers.message({
            custom: `Data inválida ou menor de 18 anos`,
          });
        }
      })
      .messages({
        'string.empty': 'Digite sua data de nascimento',
      }),
    phone: Joi.string().min(15).max(15).required().trim().messages({
      'string.empty': 'Digite o número do seu celular',
      'string.min': 'Digite o número corretamente',
      'string.max': 'Digite o número corretamente',
    }),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .trim()
      .messages({
        'string.empty': 'Digite seu email',
        'string.email': 'Digite um email válido',
      }),

      zipcode: Joi.string().min(9).max(9).required().trim().custom((_, helpers) => {
      if (invalidZipcode) {
        return helpers.message({ custom: 'CEP digitado inválido' });
      }
    }).messages({
        'string.empty': 'Digite o número do CEP',
        'string.min': 'Digite o CEP corretamente',
        'string.max': 'Digite o CEP corretamente',
    }),
    state: Joi.string().required().trim().messages({
        'string.empty': 'Selecione um estado',
    }),
    street: Joi.string().max(30).required().trim().messages({
        'string.empty': 'Digite o nome da rua',
        'string.max': 'Máximo de 30 caracteres'
    }),
    number: Joi.string().required().trim().messages({
        'string.empty': 'Digite o número da residência',
    }),
    complement: Joi.string().allow('').max(20).trim().messages({
        'string.empty': 'Digite o complemento',
        'string.max': 'Máximo de 20 caracteres'
    }),
    neighborhood: Joi.string().max(20).required().trim().messages({
        'string.empty': 'Digite o nome do bairro',
        'string.max': 'Máximo de 20 caracteres',
    }),
    city: Joi.string().min(2).required().trim().messages({
        'string.empty': 'Digite a cidade',
        'string.min': 'Mínimo de 2 caracteres'
    }),

 
  });

  const fieldChangeHandler = (field, value) => {
    if (field === 'complement' || field === 'neighborhood') {
      value = useForm.getFieldValue(field)?.substring(0, 20);
      useForm.setFieldValue(field, value);
    }

    if (field === 'number' && value === 'S/N') {
      setIsAddressWithoutNumber(true);
    }

    if (field === 'pointsQtd') {
      value = value.replace(',', '.');
    }

    setFormValues((values) => ({ ...values, [field]: value }));
  };

  const useTotalPointsHandler = (value) => {
    setIsTotalPointsChecked(value);

    if (value) {
      setFormValues((values) => ({ ...values, pointsQtd: userTotalPoints }));
      useForm.setFieldsValue({ pointsQtd: formattedUserPoints.value });
    } else {
      setFormValues((values) => ({ ...values, pointsQtd: 0 }));
      setCashValue('0');
      useForm.setFieldsValue({ pointsQtd: '0' });
    }
  };

  const acceptTermsHandler = (value) => {
    setAcceptedTerms(value);
  };

  const termsModalOpenCloseHandler = () => {
    setIsTermsModalOpen(!isTermsModalOpen);
  };

  const validateAndSubmitHandler = async () => {
    setIsLoading(true);

    try {
      const values = await useForm.validateFields();

      if (values.zipcode.length === 8) {
        values.zipcode = cepMask(values.zipcode);
      }

      if (values.number === 'S/N') values.number = '0';

      const { error } = schema.validate(values, { abortEarly: false });

      if (error) {
        const messages = {};
        error.details.forEach((err) => {
          messages[err.context.key] = err.message;
        });
        setErrorMessages(messages);
        message.error('Existem erros no formulário.');
      } else {
        setErrorMessages({});
        await updateProfile();
        await redemptionCard();
      }
    } catch (errorInfo) {
      message.error('Houve um erro durante a validação do formulário.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddressWithoutNumberCheckBox = (e) => {
    const checked = e.target.checked;
    setIsAddressWithoutNumber(checked);

    const newNumberValue = checked ? 'S/N' : '';

    setFormValues((prevValues) => ({ ...prevValues, number: newNumberValue }));
    useForm.setFieldsValue({ number: newNumberValue });
  };

  const getAddressByZipcode = async (zipcode) => {
    try {
      setIsLoading(true);

      const { user } = userInfos;

      const { data } = await cloudloyalty(user).get(`/v1/addresses/${zipcode}`);

      setInvalidZipcode(false);

      useForm.resetFields([
        'street',
        'neighborhood',
        'city',
        'state',
        'complement',
        'number',
      ]);

      useForm.setFieldsValue({
        street:
          data.street && data.streetType
            ? data.street
            : '',
        neighborhood: data.district?.substring(0, 20) || '',
        city: data.city || '',
        state: data.state || '',
      });
      setFormValues({
        ...formValues,
        street: data.street,
        neighborhood: data.district?.substring(0, 20),
        city: data.city,
        state: data.state,
      });

      useForm.validateFields([
        'street',
        'neighborhood',
        'city',
        'state',
        'complement',
        'number',
      ]);

      setErrorMessages({});
    } catch (error) {
      console.info('Ocorreu um erro ao buscar o CEP:', error);
      message.error('Erro ao buscar endereço com o cep informado');
      setInvalidZipcode(true);
      useForm.setFieldsValue({
        street: ' ',
        neighborhood: ' ',
        city: ' ',
        state: ' ',
        complement: ' ',
        number: ' ',
      });
      setFormValues({
        ...formValues,
        street: '',
        neighborhood: '',
        city: '',
        state: '',
        complement: '',
        number: '',
      });
    } finally {
      setIsLoading(false);
    }
  };

  const calculatePointsToCash = async (points) => {
    try {
      setIsLoading(true);
      const { data } = await FetchLikePlusPointsToCash(userInfos.user, points);
      setCashValue(data.money);
      const newTaxes = {};
      if (data.taxes && data.taxes.length > 0) {
        data.taxes.forEach((tax) => {
          newTaxes[tax.description] = tax.totalCalculedTax;
        });
      }

      setTaxes(newTaxes);
    } catch (error) {
      console.info('calculatePointsToCash error =>', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getOnlyNumbers = (value) => {
    const numberPattern = /\d+/g;
    return value.match(numberPattern).join([]);
  };

  const buildPhone = (phone, type) => {
    if (!phone) {
      return { areaCode: '', number: '', type };
    }

    const onlyNumbers = getOnlyNumbers(phone);
    return {
      areaCode: onlyNumbers.substr(0, 2),
      number: onlyNumbers.substr(2),
      type,
    };
  };

  const customMessage = process.env.REACT_APP_CUSTOM_CHECKOUT_2FA_MESSAGE;
  const defaultMessage = `Para garantir a segurança da sua conta e a finalização do resgate, é necessário realizar a verificação em duas etapas.`;
  const modalMessage = customMessage ? customMessage : defaultMessage;

  const redemptionCard = async () => {
    try {
      setIsLoading(true);
      const redemptionPayload = {
        totalMiles: cashValue,
        totalPoints: formValues.pointsQtd,
        transferKey: 'cpf',
        loyaltyNumber: formValues.document,
        cpf: formValues.document,
        participantName: formValues.fullName,
        orderItems: [
          {
            miles: cashValue,
            packageName: `Crédito Cartão Pré-Pago ${cardCustomLabel}`,
            quantity: 1,
            totalPoints: convertPriceToPoints(
              conversionRate,
              decimalPlaces,
              cashValue
            ),
          },
        ],
        offline: false,
        orderTypeId: 3,
      };

      if (taxes) {
        Object.entries(taxes).forEach(([description, totalCalculedTax]) => {
          redemptionPayload.orderItems.push({
            miles: totalCalculedTax.toString(),
            packageName: description,
            quantity: 1,
            totalPoints: convertPriceToPoints(
              conversionRate,
              decimalPlaces,
              totalCalculedTax
            ),
          });
        });
      }

      setPurchaseData(redemptionPayload);
      const { data } = await FetchLikePlusRedemption(
        userInfos.user,
        redemptionPayload
      );

      if (
        data &&
        (data?.order?.liveOrderId || data?.id) &&
        data?.status !== 'RequiresTokenValidation' &&
        !data?.errors
      ) {
        const orderId = data.order.liveOrderId || data?.id;
        navigate(`/order-details?orderId=${orderId}&fromLikePlus=true`);
      } else if (
        data &&
        data?.status === 'RequiresTokenValidation' &&
        !data?.errors
      ) {
        setOrderStatus(data?.status);
        setOrderId(data?.order?.liveOrderId || data?.id);
      } else if (
        data &&
        data?.errors &&
        typeof data?.errors === 'string' &&
        /^(406)+/g.test(data?.errors)
      ) {
        const errorString = data?.errors.replace('406 -', '').trim();
        const error = JSON.parse(errorString);
        switch (error.status) {
          case 'AUTHENTICATIONREQUIRED':
            setOrderStatus(error.errors[0].code);
            setOrderId(error?.id);
            break;
          default:
            handleAddErrors('likePlusGetYour2FA', {
              title: 'Não foi possível concluir.',
              message:
                'Para garantir a segurança da sua conta, é necessário validar o seu número de telefone antes de prosseguir. Entre em contato com a central de atendimento.',
            });
            setIsErrorModal(true);
            setShowOnboardingModal(true);
        }
      } else {
        setIsErrorModalMessage(data.message);
        setIsErrorModal(true);
      }
    } catch (error) {
      if (error) {
        console.info('redemptionCard Error =>', error);
        if (
          error?.response?.data?.status &&
          error?.response?.data?.status === 'MessageOnBoardingRequired'
        ) {
          setIsErrorModalMessage(modalMessage);
          setIsErrorModal(true);
        } else {
          setIsErrorModalMessage('Por favor tente novamente em instantes');
          setIsErrorModal(true);
        }
      }
    } finally {
      setIsLoading(false);
    }
  };

  const updateProfile = async () => {
    const aliasProfile = generateUUID();
    const aliasAddress = generateUUID();

    const arrayEmails = Participants.mails.value;
    const workEmails = arrayEmails.filter(
      (emailObj) => emailObj.type === 'WORK'
    );

    const profileData = {
      birthDate: convertStringToDate(formValues.birthDate),
      documentNumber: getOnlyNumbers(formValues.document),
      emails: [{ email: formValues.email, type: 'PERSONAL' }, ...workEmails],
      genderType: 'UNINFORMED',
      status: 'ACTIVE',
      name: formValues.fullName,
      phones: [buildPhone(formValues.phone, 'MOBILE')],
      profileId: Participants?.profileId,
    };

    const addressData = {
      street: formValues.street,
      number: formValues.number,
      complement: formValues.complement
        ? formValues.complement.substring(0, 20)
        : 'Nenhum',
      district: formValues.neighborhood?.substring(0, 20),
      city: formValues.city,
      state: formValues.state,
      zipCode: getOnlyNumbers(formValues.zipcode),
      reference: formValues.reference,
    };

    try {
      setIsLoading(true);
      const addressPayload = addressData;
      const profilePayload =
        Participants.personType === 1
          ? { ...profileData, personType: 'INDIVIDUAL' }
          : {
              ...profileData,
              personType: 'COMPANY',
              partnerCpf: getOnlyNumbers(formValues.document),
            };

      await callApi({
        symbol: `UPDATE_PARTICIPANT`,
        alias: aliasProfile,
        payload: profilePayload,
      });

      await callApi({
        symbol: `UPDATE_CART_SHIPPING`,
        alias: aliasAddress,
        payload: {
          shippingAddress: addressPayload,
          customer: { ...profilePayload, email: formValues.email },
        },
      });
    } catch (error) {
      console.info('updateProfile Error =>', error);
    } finally {
      setIsLoading(false);
    }
  };

  const validateFormFilled = () => {
    let formValuesArray = [];
    for (let prop in formValues)
      if (prop != 'complement')
        //O campo complement não é obrigatório, então não levamos em consideração para verficar se está preenchido
        formValuesArray.push(formValues[prop]);
    return formValuesArray.every(
      (value) => value !== '' && value !== '0' && value !== 0
    );
  };

  const designTokens = localStorage.getItem('designTokens');
  const initialTokensValuesFinal =
    (designTokens && JSON.parse(designTokens)) || initialTokensValues;
  const title =
    process.env.REACT_APP_HAS_LIKE_PLUS_CUSTOM_TITLE || 'Cartão like mais';

  const alertWarningProfileText = process.env.REACT_APP_ALERT_WARNING_PROFILE_TEXT;

  const desktopContent = (
    <VertContainer className="like-plus-get-your-component">


      <Row>
        <Col className="like-plus-info col-9">
          <Row className="title">
            <Col className="col">
              <VertTypography.Title>
                Para começar, faça sua primeira carga:
              </VertTypography.Title>
            </Col>
          </Row>

          <Row className="balance">
            <Col className="col">
              <VertTypography.Paragraph>
                Seu saldo: {formattedUserPoints.value}{' '}
                {formattedUserPoints.label}
              </VertTypography.Paragraph>
            </Col>
          </Row>

          

          <Row className="points-to-use-fields">
            <Col className="points-value col-4">
              <VertTypography.Paragraph>
                Carga inicial do cartão em {pointsName}
              </VertTypography.Paragraph>

              <Form.Item
                name="pointsQtd"
                initialValue=""
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.pointsQtd}
              >
                <VertInput
                  className={errorMessages.pointsQtd ? 'error-message' : ''}
                  placeholder={`Digite a qtd. de ${pointsName}`}
                  onChange={({ target }) =>
                    fieldChangeHandler('pointsQtd', target.value)
                  }
                  template="marketplace"
                  onKeyPress={(e) =>
                    onlyNumbersByDecimalPlaces(e, decimalPlaces)
                  }
                  disabled={isTotalPointsChecked}
                />
              </Form.Item>
            </Col>
            <Col className="card-value col-4">
              <VertTypography.Paragraph>
                Valor no cartão {cardCustomLabel}
              </VertTypography.Paragraph>
              {isLoading && (
                <VertLoading
                  size={'small'}
                  color={initialTokensValuesFinal['color-detached']}
                />
              )}
              {!isLoading && (
                <VertInput
                  value={currencyMask(Number(cashValue))}
                  template="marketplace"
                  disabled
                />
              )}
            </Col>
          </Row>

          <Form.Item>
            <VertCheckbox
              className="total-points-value-checkbox"
              name="total-points"
              defaultChecked={false}
              onChange={(e) => useTotalPointsHandler(e.target.checked)}
            >
              Usar todo meu saldo de {pointsName}
            </VertCheckbox>
          </Form.Item>

          {
            (minCardLoad || maxCardLoad) && (
                <Row className='important-warning'>
                    <Col className='col'>
                        <VertTypography.Paragraph className='important-warning-title'>
                            <span>Regras da primeira carga</span>
                        </VertTypography.Paragraph>

                        {minCardLoad && (
                            <VertTypography.Paragraph type='light'>
                                • Limite mínimo de {`${formattedLikePlusLoadMinLimit?.value} ${formattedLikePlusLoadMinLimit?.label}`}.
                            </VertTypography.Paragraph>
                        )}

                        {maxCardLoad && (
                            <VertTypography.Paragraph type='light'>
                                • Limite máximo de {`${formattedLikePlusLoadMaxLimit?.value} ${formattedLikePlusLoadMaxLimit?.label}`}.
                            </VertTypography.Paragraph>
                        )}
                    </Col>
                </Row>
            )
          }

          <Row className="important-warning">
            <Col className="col">
              <VertTypography.Paragraph className="important-warning-title">
                <span>Previsão de entrega para esse endereço</span>
              </VertTypography.Paragraph>
              <VertTypography.Paragraph className="important-warning-text">
                O primeiro resgate do cartão {cardCustomLabel} será processado e enviado em até {deliveryTime}.
              </VertTypography.Paragraph>
              <VertTypography.Paragraph className="important-warning-title">
                <span>Informações importantes</span>
              </VertTypography.Paragraph>
              <VertTypography.Paragraph className="important-warning-text">
                O cartão será entregue no endereço de cadastro. Você pode editar
                seu endereço a seguir, se desejar.
              </VertTypography.Paragraph>
              <VertTypography.Paragraph className="important-warning-text">
                Enviaremos para o seu endereço uma carta registrada com:
              </VertTypography.Paragraph>
              <Col className="important-warning-list padding-x-none padding-y-none">
                <VertTypography.Paragraph>
                  (1) Seu cartão pré-pago {cardCustomLabel}
                </VertTypography.Paragraph>
                <VertTypography.Paragraph>
                  (2) Informações sobre ativação do cartão
                </VertTypography.Paragraph>
                <VertTypography.Paragraph>
                  (3) Instruções de uso
                </VertTypography.Paragraph>
                <VertTypography.Paragraph>
                  (4) Contatos da central de atendimento
                </VertTypography.Paragraph>
              </Col>
            </Col>
          </Row>

        </Col>

        <Col className="like-plus-summary col-3">
          <VertTypography.Paragraph className="summary-title">
            Resumo do resgate
          </VertTypography.Paragraph>

          <Col className="divider" />

          {Object.keys(taxes).length > 0 && (
            <div className={'margin-bottom-small'}>
              {Object.keys(taxes).map((key) => (
                <VertTypography.Paragraph
                  className={'padding-top-small'}
                  key={key}
                >
                  {key}: {currencyMask(parseFloat(taxes[key]))}
                </VertTypography.Paragraph>
              ))}

              <Col className="divider" />
            </div>
          )}

          <VertTypography.Paragraph className="summary-subtitle">
            Cartão {cardCustomLabel}
          </VertTypography.Paragraph>

          <VertTypography.Paragraph className="summary-text">
            Saldo adicionado ao cartão:{' '}
            {!isLoading &&
              (cashValue ? currencyMask(Number(cashValue)) : 'R$ 0')}
            {isLoading && (
              <VertLoading
                size={'small'}
                color={initialTokensValuesFinal['color-detached']}
              />
            )}
          </VertTypography.Paragraph>

          <Col className="divider" />

          <VertTypography.Paragraph className="summary-text" strong>
            {`Total em ${pointsName}: `}
            <span>
              {!isLoading &&
                (formValues.pointsQtd
                  ? `${formattedPointsQtd.value} ${formattedPointsQtd.label}`
                  : `0 ${formattedPointsQtd.label}`)}
            </span>
            {isLoading && (
              <VertLoading
                size={'small'}
                color={initialTokensValuesFinal['color-detached']}
              />
            )}
          </VertTypography.Paragraph>

          <Col className="divider" />

          <Col className="col-auto padding-x-none padding-y-none">
            <VertCheckbox
              className="summary-checkbox"
              name="total-points"
              defaultChecked={false}
              onChange={(e) => acceptTermsHandler(e.target.checked)}
            >
              Li e aceito o{' '}
              <a role="button" onClick={termsModalOpenCloseHandler}>
                Termo de uso
              </a>
              .
            </VertCheckbox>
          </Col>

          <Col className="col-auto padding-x-none padding-y-none">
            <VertButton
              type="highlight"
              onClick={validateAndSubmitHandler}
              loading={isLoading}
              disabled={disableButton || isLoading}
            >
              Finalizar resgate
            </VertButton>
          </Col>
        </Col>
      </Row>

      {
        profileEditionUrl && (
          <Col className="col-7 margin-y-small">
            <VertAlert 
              type="warning"
              message={
                <>
                  Qualquer alteração de dados cadastrais deve ser feita no {profileEditionPortal}.
                  <a href={profileEditionUrl} target="_blank">{` Clique aqui`}</a> e vá para Meu Cadastro.
                </>
              }
            />
          </Col>
        )
      }

      <Col className="like-plus-forms-wrapper col-7">
        <Row className="personal-data-form">

       
          <Col className="col">
            <VertTypography.Paragraph className="personal-data-title">
              Dados pessoais
            </VertTypography.Paragraph>

            <Row className="name-field">
              <Col className="col">
                <Form.Item
                  name="fullName"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.fullName}
                >
                  <VertInput
                    label="Nome Completo"
                    template="marketplace"
                    disabled={Participants.name.disabled}
                    className={errorMessages.fullName ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('fullName', target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="document-birthdate-field">
              <Col className="col">
                <Form.Item
                  name="document"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.document}
                >
                  <VertInput
                    label="CPF"
                    template="marketplace"
                    disabled={Participants.cpf.disabled}
                    className={errorMessages.document ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('document', target.value)
                    }
                    mask={[
                      {
                        mask: '000.000.000-00',
                        lazy: true,
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col className="col">
                <Form.Item
                  name="birthDate"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.birthDate}
                >
                  <VertInput
                    label="Data de nascimento"
                    template="marketplace"
                    disabled={Participants.birthDate.disabled}
                    className={errorMessages.birthDate ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('birthDate', target.value)
                    }
                    mask={[
                      {
                        mask: '00/00/0000',
                        lazy: true,
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="phone-email-field">
              <Col className="col">
                <Form.Item
                  name="phone"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.phone}
                >
                  <VertInput
                    label="Celular"
                    template="marketplace"
                    className={errorMessages.phone ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('phone', target.value)
                    }
                    mask={[
                      {
                        mask: '(00) 00000-0000',
                        lazy: true,
                      },
                    ]}
                    disabled={Participants.phone.disabled}
                  />
                </Form.Item>
              </Col>
              <Col className="col">
                <Form.Item
                  name="email"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.email}
                >
                  <VertInput
                    label="E-mail"
                    template="marketplace"
                    disabled={Participants.email.disabled}
                    className={errorMessages.email ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('email', target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>

        <Row className="address-form">
          <Col className="col">
            <VertTypography.Paragraph className="address-title">
              Endereço de entrega
            </VertTypography.Paragraph>

            <Row className="zipcode-state-field">
              <Col className="col">
                <Form.Item
                  name="zipcode"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.zipcode}
                  rules={[
                    { required: true, message: 'CEP precisa ser preenchido.' },
                    { max: 9, message: 'CEP deve ter no máximo 9 caracteres.' },
                  ]}
                >
                  <VertInputMask
                    label="CEP"
                    name="cep"
                    mask="99999-999"
                    value={formValues.zipcode}
                    onChange={(val) => {
                      fieldChangeHandler('zipcode', val);
  
                      if (val.length === 8) getAddressByZipcode(val);
                    }}
                    disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                  />
                </Form.Item>
              </Col>
              <Col className="col">
                <Form.Item
                  name="state"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.state}
                  className="form-item-state-list"
                  rules={[
                    { required: true, message: 'UF precisa ser preenchido.' },
                  ]}
                >
                  <VertSelect
                    label="UF"
                    placeholder="Estado"
                    template="marketplace"
                    showSearch
                    items={StateList}
                    disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                    loading={isLoading}
                    status={errorMessages.state ? 'error' : 'default'}
                    onChange={(value) => fieldChangeHandler('state', value)}
                    className={`state-list ${
                      errorMessages.state ? 'error-message' : ''
                    }`}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="street-field">
              <Col className="col">
                <Form.Item
                  name="street"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.street}
                  rules={[
                    {
                      required: true,
                      message: 'Endereço precisa ser preenchido.',
                    },
                    {
                      min: 5,
                      message: 'Endereço deve ter no máximo 30 caracteres.',
                    },
                  ]}
                >
                  <VertInput
                    label="Endereço"
                    template="marketplace"
                    className={errorMessages.street ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('street', target.value)
                    }
                    disabled={!yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS) || isLoading}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="number-complement-neighborhood-field">
              <Col className="col">
                <div>
                  <Form.Item
                    name="number"
                    initialValue={''}
                    validateTrigger={['onBlur', 'onChange']}
                    help={errorMessages.number}
                    rules={[
                      {
                        required: true,
                        message: 'Número precisa ser preenchido.',
                      },
                      {
                        max: 20,
                        message: 'Número deve ter no máximo 20 caracteres.',
                      },
                      {
                        pattern: /^(S\/N|\d+)$/,
                        message: 'Somente números ou S/N.',
                      },
                    ]}
                    className="form-item-number"
                  >
                    <VertInput
                      label="Número"
                      template="marketplace"
                      className={errorMessages.number ? 'error-message' : ''}
                      onChange={({ target }) => {
                        fieldChangeHandler('number', target.value);
                      }}
                      disabled={isAddressWithoutNumber || isLoading  || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)} 
                      value={formValues.number}
                    />
                  </Form.Item>
                  <Form.Item noStyle>
                    <VertCheckbox
                      checked={isAddressWithoutNumber}
                      onChange={handleAddressWithoutNumberCheckBox}
                      disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                      template="marketplace"
                      className="vert-checkbox-address-likeplus"
                    >
                      Sem Número
                    </VertCheckbox>
                  </Form.Item>
                </div>
              </Col>
              <Col className="col">
                <Form.Item
                  name="complement"
                  className="complement-form-item"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.complement}
                  rules={[
                    {
                      required: true,
                      message: 'Digite o complemento',
                    },
                    {
                      max: 20,
                      message: 'Complemento deve ter no máximo 20 caracteres.',
                    },
                  ]}
                >
                  <VertInput
                    label="Complemento"
                    template="marketplace"
                    className={errorMessages.complement ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('complement', target.value)
                    }
                    maxLength={20}
                    disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                  />
                </Form.Item>
              </Col>
              <Col className="col">
                <Form.Item
                  name="neighborhood"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.neighborhood}
                  rules={[
                    {
                      required: true,
                      message: 'Bairro precisa ser preenchido.',
                    },
                    {
                      max: 20,
                      message: 'Bairro deve ter no máximo 20 caracteres.',
                    },
                  ]}
                >
                  <VertInput
                    label="Bairro"
                    template="marketplace"
                    className={
                      errorMessages.neighborhood ? 'error-message' : ''
                    }
                    onChange={({ target }) =>
                      fieldChangeHandler('neighborhood', target.value)
                    }
                    maxLength={20}
                    disabled={!yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS) || isLoading}
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row className="city-reference-field">
              <Col className="col">
                <Form.Item
                  name="city"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.city}
                  rules={[
                    
                    {
                      required: true,
                      message: 'Cidade precisa ser preenchida.',
                    },
                    {
                      min: 2,
                      message: 'Cidade deve ter no mínimo 2 caracteres.',
                    },
                  ]}
                >
                  <VertInput
                    label="Cidade"
                    template="marketplace"
                    disabled={!yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS) || isLoading}
                    className={errorMessages.city ? 'error-message' : ''}
                    onChange={({ target }) =>
                      fieldChangeHandler('city', target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </VertContainer>
  );

  const mobileContent = (
    <VertContainer
      className="like-plus-get-your-component"
      spacingX="small"
      spacingY="small"
    >
      <Row className="title">
        <Col className="col">
          <VertTypography.Title>
            Para começar, faça sua primeira carga:
          </VertTypography.Title>
        </Col>
      </Row>

      <Row className="balance">
        <Col className="col">
          <VertTypography.Paragraph>
            Seu saldo: {formattedUserPoints.value} {formattedUserPoints.label}
          </VertTypography.Paragraph>
        </Col>
      </Row>

      <Col className="points-to-use-fields">
        <Col className="points-value col">
          <VertTypography.Paragraph>Carga inicial do cartão em {pointsName}</VertTypography.Paragraph>
          <Form.Item
            name="pointsQtd"
            initialValue=""
            validateTrigger={['onBlur', 'onChange']}
            help={errorMessages.pointsQtd}
          >
            <VertInput
              className={errorMessages.pointsQtd ? 'error-message' : ''}
              placeholder={`Digite a qtd. de ${pointsName}`}
              onChange={({ target }) =>
                fieldChangeHandler('pointsQtd', target.value)
              }
              template="marketplace"
              onKeyPress={(e) => onlyNumbersByDecimalPlaces(e, decimalPlaces)}
              disabled={isTotalPointsChecked}
            />
          </Form.Item>
        </Col>

        <Form.Item>
          <VertCheckbox
            className="total-points-value-checkbox"
            name="total-points"
            defaultChecked={false}
            onChange={(e) => useTotalPointsHandler(e.target.checked)}
          >
            Usar todo meu saldo de {pointsName}
          </VertCheckbox>
        </Form.Item>

        <Col className="card-value col">
          <VertTypography.Paragraph>Valor no {title}</VertTypography.Paragraph>
          {isLoading && (
            <VertLoading
              size={'small'}
              color={initialTokensValuesFinal['color-detached']}
            />
          )}
          {!isLoading && (
            <VertInput
              value={currencyMask(Number(cashValue))}
              template="marketplace"
              disabled
            />
          )}
        </Col>
      </Col>

      {
        (minCardLoad || maxCardLoad) && (
            <Row className='important-warning'>
                <Col className='col'>
                    <VertTypography.Paragraph className='important-warning-title'>
                        <span>Regras da primeira carga</span>
                    </VertTypography.Paragraph>

                    {minCardLoad && (
                        <VertTypography.Paragraph type='light'>
                            • Limite mínimo de {`${formattedLikePlusLoadMinLimit?.value} ${formattedLikePlusLoadMinLimit?.label}`}.
                        </VertTypography.Paragraph>
                    )}

                    {maxCardLoad && (
                        <VertTypography.Paragraph type='light'>
                            • Limite máximo de {`${formattedLikePlusLoadMaxLimit?.value} ${formattedLikePlusLoadMaxLimit?.label}`}.
                        </VertTypography.Paragraph>
                    )}
                </Col>
            </Row>
        )
      }

      <Row className="important-warning">
        <Col className="col">
          <VertTypography.Paragraph className="important-warning-title">
            <span>Previsão de entrega para esse endereço</span>
          </VertTypography.Paragraph>
          <VertTypography.Paragraph className="important-warning-text">
            O primeiro resgate do cartão {cardCustomLabel} será processado e enviado em até {deliveryTime}.
          </VertTypography.Paragraph>
          <VertTypography.Paragraph className="important-warning-title">
            <span>Informações importantes</span>
          </VertTypography.Paragraph>
          <VertTypography.Paragraph className="important-warning-text">
            O cartão será entregue no endereço de cadastro. Você pode editar seu
            endereço a seguir, se desejar.
          </VertTypography.Paragraph>
          <VertTypography.Paragraph className="important-warning-text">
            Enviaremos para o seu endereço uma carta registrada com:
          </VertTypography.Paragraph>
          <Col className="important-warning-list padding-x-none padding-y-none">
            <VertTypography.Paragraph>
              (1) Seu cartão pré-pago {title}
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              (2) Informações sobre ativação do cartão
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              (3) Instruções de uso
            </VertTypography.Paragraph>
            <VertTypography.Paragraph>
              (4) Contatos da central de atendimento
            </VertTypography.Paragraph>
          </Col>
        </Col>
      </Row>

      {
        profileEditionUrl && (
          <Col className="margin-y-small">
            <VertAlert 
              type="warning"
              message={
                <>
                  Qualquer alteração de dados cadastrais deve ser feita no {profileEditionPortal}.
                  <a href={profileEditionUrl} target="_blank">{` Clique aqui`}</a> e vá para Meu Cadastro.
                </>
              }
            />
          </Col>
        )
      }

      <Col className="like-plus-forms-wrapper col">
        <Col className="personal-data-form">
          <VertTypography.Paragraph className="personal-data-title">
            Dados pessoais
          </VertTypography.Paragraph>

          <Row className="name-field">
            <Col className="col">
              <Form.Item
                name="fullName"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.fullName}
              >
                <VertInput
                  label="Nome Completo"
                  template="marketplace"
                  disabled={Participants.name.disabled}
                  className={errorMessages.fullName ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('fullName', target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="document-field">
            <Col className="col">
              <Form.Item
                name="document"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.document}
              >
                <VertInput
                  label="CPF"
                  template="marketplace"
                  disabled={Participants.cpf.disabled}
                  className={errorMessages.document ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('document', target.value)
                  }
                  mask={[
                    {
                      mask: '000.000.000-00',
                      lazy: true,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="birthdate-field">
            <Col className="col">
              <Form.Item
                name="birthDate"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.birthDate}
              >
                <VertInput
                  label="Data de nascimento"
                  template="marketplace"
                  disabled={Participants.birthDate.disabled}
                  className={errorMessages.birthDate ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('birthDate', target.value)
                  }
                  mask={[
                    {
                      mask: '00/00/0000',
                      lazy: true,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="phone-field">
            <Col className="col">
              <Form.Item
                name="phone"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.phone}
              >
                <VertInput
                  label="Celular"
                  template="marketplace"
                  className={errorMessages.phone ? 'error-message' : ''}
                  disabled={Participants.phone.disabled}
                  onChange={({ target }) =>
                    fieldChangeHandler('phone', target.value)
                  }
                  mask={[
                    {
                      mask: '(00) 00000-0000',
                      lazy: true,
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="email-field">
            <Col className="col">
              <Form.Item
                name="email"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.email}
              >
                <VertInput
                  label="E-mail"
                  template="marketplace"
                  disabled={Participants.email.disabled}
                  className={errorMessages.email ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('email', target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col className="address-form">
          <VertTypography.Paragraph className="address-title">
            Endereço de entrega
          </VertTypography.Paragraph>

          <Row className="zipcode-field">
            <Col className="col">
              <Form.Item
                name="zipcode"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.zipcode}
                rules={[
                  { required: true, message: 'CEP precisa ser preenchido.' },
                  { max: 9, message: 'CEP deve ter no máximo 9 caracteres.' },
                ]}
              >
                <VertInputMask
                  label="CEP"
                  name="cep"
                  mask="99999-999"
                  value={formValues.zipcode}
                  onChange={(val) => {
                    fieldChangeHandler('zipcode', val);

                    if (val.length === 8) getAddressByZipcode(val);
                  }}
                  disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="state-field">
            <Col className="col">
              <Form.Item
                name="state"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.state}
                className="form-item-state-list"
                rules={[
                  { required: true, message: 'UF precisa ser preenchido.' },
                ]}
              >
                <VertSelect
                  label="UF"
                  placeholder="Estado"
                  template="marketplace"
                  showSearch
                  items={StateList}
                  disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                  loading={isLoading}
                  status={errorMessages.state ? 'error' : 'default'}
                  onChange={(value) => fieldChangeHandler('state', value)}
                  className={`state-list ${
                    errorMessages.state ? 'error-message' : ''
                  }`}

                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="street-field">
            <Col className="col">
              <Form.Item
                name="street"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.street}
                rules={[
                  {
                    required: true,
                    message: 'Endereço precisa ser preenchido.',
                  },
                  {
                    max: 30,
                    message: 'Endereço deve ter no máximo 30 caracteres.',
                  },
                ]}
              >
                <VertInput
                  label="Endereço"
                  template="marketplace"
                  disabled={!yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS) || isLoading}
                  className={errorMessages.street ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('street', target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="number-field">
            <Col className="col">
              <div>
                <Form.Item
                  name="number"
                  initialValue={''}
                  validateTrigger={['onBlur', 'onChange']}
                  help={errorMessages.number}
                  rules={[
                    {
                      required: true,
                      message: 'Número precisa ser preenchido.',
                    },
                    {
                      max: 20,
                      message: 'Número deve ter no máximo 20 caracteres.',
                    },
                    {
                      pattern: /^(S\/N|\d+)$/,
                      message: 'Somente números ou S/N.',
                    },
                  ]}
                  className="form-item-number"
                >
                  <VertInput
                    label="Número"
                    template="marketplace"
                    className={errorMessages.number ? 'error-message' : ''}
                    onChange={({ target }) => {
                      if (!/^(S\/N|\d+)$/.test(target.value)) {
                        useForm.setFields([
                          {
                            name: 'number',
                            errors: ['Somente números ou S/N.'],
                          },
                        ]);
                      }
                      fieldChangeHandler('number', target.value);
                    }}
                    disabled={isAddressWithoutNumber || isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                    value={formValues.number}
                  />
                </Form.Item>
                <Form.Item noStyle>
                  <VertCheckbox
                    checked={isAddressWithoutNumber}
                    onChange={handleAddressWithoutNumberCheckBox}
                    disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                    template="marketplace"
                    className="vert-checkbox-address-likeplus"
                  >
                    Sem Número
                  </VertCheckbox>
                </Form.Item>
              </div>
            </Col>
          </Row>

          <Row className="complement-field">
            <Col className="col">
              <Form.Item
                name="complement"
                className="complement-form-item"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.complement}
                rules={[
                  {
                    max: 20,
                    message: 'Complemento deve ter no máximo 20 caracteres.',
                  },
                ]}
              >
                <VertInput
                  label="Complemento"
                  template="marketplace"
                  className={errorMessages.complement ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('complement', target.value)
                  }
                  maxLength={20}
                  disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="neighborhood-field">
            <Col className="col">
              <Form.Item
                name="neighborhood"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.neighborhood}
                rules={[
                  { required: true, message: 'Bairro precisa ser preenchido.' },
                  {
                    max: 20,
                    message: 'Bairro deve ter no máximo 20 caracteres.',
                  },
                ]}
              >
                <VertInput
                  label="Bairro"
                  template="marketplace"
                  className={errorMessages.neighborhood ? 'error-message' : ''}
                  disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                  onChange={({ target }) =>
                    fieldChangeHandler('neighborhood', target.value)
                  }
                  maxLength={20}

                />
              </Form.Item>
            </Col>
          </Row>

          <Row className="city-field">
            <Col className="col">
              <Form.Item
                name="city"
                initialValue={''}
                validateTrigger={['onBlur', 'onChange']}
                help={errorMessages.city}
              >
                <VertInput
                  label="Cidade"
                  template="marketplace"
                  disabled={isLoading || !yn(process.env.REACT_APP_HAS_EDIT_PERSONAL_INFORMATIONS)}
                  className={errorMessages.city ? 'error-message' : ''}
                  onChange={({ target }) =>
                    fieldChangeHandler('city', target.value)
                  }
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>
      </Col>

      <Col className="like-plus-summary col">
        <VertTypography.Paragraph className="summary-title">
          Resumo do resgate
        </VertTypography.Paragraph>

        <Col className="divider" />

        {Object.keys(taxes).length > 0 && (
            <div className={'margin-bottom-small'}>
              {Object.keys(taxes).map((key) => (
                <VertTypography.Paragraph
                  className={'padding-top-small'}
                  key={key}
                >
                  {key}: {currencyMask(parseFloat(taxes[key]))}
                </VertTypography.Paragraph>
              ))}

              <Col className="divider" />
            </div>
          )}

        <VertTypography.Paragraph className="summary-subtitle">
          {title}
        </VertTypography.Paragraph>

        <VertTypography.Paragraph className="summary-text">
          Saldo adicionado ao cartão:{' '}
          {!isLoading && (cashValue ? currencyMask(Number(cashValue)) : 'R$ 0')}
          {isLoading && (
            <VertLoading
              size={'small'}
              color={initialTokensValuesFinal['color-detached']}
            />
          )}
        </VertTypography.Paragraph>

        <Col className="divider" />

        <VertTypography.Paragraph className="summary-text" strong>
          {`Total em ${pointsName}: `}
          {!isLoading &&
            (formValues.pointsQtd
              ? `${formattedPointsQtd.value} ${formattedPointsQtd.label}`
              : `0 ${formattedPointsQtd.label}`)}
          {isLoading && (
            <VertLoading
              size={'small'}
              color={initialTokensValuesFinal['color-detached']}
            />
          )}
        </VertTypography.Paragraph>

        <Col className="divider" />

        <Col className="col-auto padding-x-none padding-y-none">
          <VertCheckbox
            className="summary-checkbox"
            name="total-points"
            defaultChecked={false}
            onChange={(e) => acceptTermsHandler(e.target.checked)}
          >
            Li e aceito o{' '}
            <a role="button" onClick={termsModalOpenCloseHandler}>
              Termo de uso
            </a>
            .
          </VertCheckbox>
        </Col>
        <Col className="col-auto padding-x-none padding-y-none">
          <VertButton
            type="highlight"
            onClick={validateAndSubmitHandler}
            loading={isLoading}
            disabled={disableButton}
          >
            Finalizar resgate
          </VertButton>
        </Col>
      </Col>
    </VertContainer>
  );

  useEffect(() => {
    let addressNumber = handleAddressNumberOutput(
      Participants?.address.number.value
    );

    if (addressNumber == 'S/N') setIsAddressWithoutNumber(true);

    let defaultPhone = Participants?.phones?.mobile;
    if (!defaultPhone?.number) defaultPhone = Participants?.phone;

    useForm.setFieldsValue({
      pointsQtd: formValues.pointsQtd,
      fullName: Participants?.name.value,
      document: Participants?.cpfCnpj.value,
      birthDate: Participants?.birthDate.value,
      phone: phoneMask(
        defaultPhone?.areaCode,
        defaultPhone?.number
      ),
      email: Participants?.email.value,
      zipcode: cepMask(Participants?.address.zipCode.value),
      state: Participants?.address.state.value,
      street: Participants?.address.addressText.value,
      number: addressNumber,
      complement: Participants?.address.complement.value,
      neighborhood: Participants?.address.district.value,
      city: Participants?.address.city.value,
      reference: 'Nenhum',
    });

    setFormValues({
      pointsQtd: 0,
      fullName: Participants?.name.value,
      document: Participants?.cpfCnpj.value,
      birthDate: Participants?.birthDate.value,
      phone: phoneMask(
        Participants?.phone.areaCode,
        Participants?.phone.number
      ),
      email: Participants?.email.value,
      zipcode: cepMask(Participants?.address.zipCode.value),
      state: Participants?.address.state.value,
      street: Participants?.address.addressText.value,
      number: addressNumber,
      complement: Participants?.address.complement.value,
      neighborhood: Participants?.address.district.value,
      city: Participants?.address.city.value,
      reference: 'Nenhum',
    });
  }, []);

  useEffect(() => {
    const formFilled = validateFormFilled();
    setIsFormFilled(formFilled);
  }, [formValues]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {   
      if (formValues.pointsQtd > 0) {
        calculatePointsToCash(formValues.pointsQtd);
      }

      if (formValues.pointsQtd < minCardLoad) {
        setTaxes({});
        setCashValue('0');
      } 
    }, 450);

    return () => clearTimeout(timeoutId);
  }, [formValues.pointsQtd]);


  return (
    <>
      <CheckoutModal2FA
        purchaseData={purchaseData}
        propsServiceName={'GETPLUSYOUR'}
        propsOrderId={orderId}
        propsStatus={orderStatus}
      />

      <Form name="getYourLikePlusCardForm" form={useForm}>
        <MediaQuery minWidth={769}>{desktopContent}</MediaQuery>

        <MediaQuery maxWidth={768}>{mobileContent}</MediaQuery>

        {isTermsModalOpen && (
          <VertModal
            width={"45%"}
            open={isTermsModalOpen}
            onCancel={termsModalOpenCloseHandler}
          >
            <LikePlusCustomTerms />
          </VertModal>
        )}

        {isErrorModal && (
          errors['likePlusGetYour2FA']
            ? (
              <OnboardingRedirectModal 
                open={showOnboardingModal}
                handleClose={() => setShowOnboardingModal(false)}
              />
            ) : (
              <VertModal
                open={isErrorModal}
                onCancel={() => setIsErrorModal(false)}
                template="marketplace"
                spacing="regular"
                rootClassName="like-plus-error-modal"
              >
                <Col className="like-plus-error-modal-content">
                  <VertIcon component={InfoCircleOutlined} />
                  <VertTypography.Paragraph className="title">
                    Não foi possivel solicitar o seu cartão
                  </VertTypography.Paragraph>
    
                  <VertTypography.Paragraph className="message">
                    {errorModalMessage}
                  </VertTypography.Paragraph>
    
                  <VertButton
                    type="highlight"
                    onClick={() => setIsErrorModal(false)}
                  >
                    Entendi
                  </VertButton>
                </Col>
              </VertModal>
            )
        )}
      </Form>
    </>
  );
};

export default LikePlusGetYour;
